import { useState } from "react";
import styles from "./devicefilter.module.css";
import { Link } from "react-router-dom";
import { ArrowRight, Filter, Key, Plus, Search, Smartphone } from "react-feather";
import { Dropdown } from "react-bootstrap";
import { useAuth0 } from "@auth0/auth0-react";
import FilterAutocomplete from "../../../../../../components/FilterAutocomplete";

const statusOptions = [
    { value: 1, label: "Online" },
    { value: 0, label: "Offline" },
];

const locationOptions = [
    { value: "Bathroom", label: "Bathroom" },
    { value: "Bedroom", label: "Bedroom" },
    { value: "Bedroom Closet", label: "Bedroom Closet" },
    { value: "Living Room", label: "Living Room" },
    { value: "Living Room Closet", label: "Living Room Closet" },
];

const productOptions = [
    { value: "Propertydek-Door Lock", label: "Door Lock" },
    { value: "Propertydek-Light", label: "Dimmer" },
    { value: "Propertydek-Thermostat", label: "Thermostat" },
    { value: "Propertydek-Lock Gateway", label: "Lock Gateway" },
];

const DeviceFilter = ({ filterData, setFilterData, setPage, setShowAddFormNew, setShowAddFormNew2 }) => {
    const { user, isAuthenticated } = useAuth0();
    const [filterOpen, setFilterOpen] = useState(false);

    // Any search/filter change starts again from the first page
    const updateFilter = (key, value) => {
        setFilterData((prev) => ({ ...prev, [key]: value }));
        setPage(0);
    };

    return <div className={`${styles.NotesSearchArea}`}>
        <div className={`${styles.FilterSearchSec}`}>
            <div className={`${styles.NotesSearchMain}`}>
                <Search />
                <input type="text" placeholder="Search" className={`${styles.searchInput}`} value={filterData?.searchKey} onChange={(e) => updateFilter("searchKey", e.target.value)} />
            </div>
        </div>
        <div className={`${styles.FilterSec}`}>
            <div className={filterOpen === true ? `${styles.FilterFieldSec} ${styles.Open}` : `${styles.FilterFieldSec}`}>
                <p className={`${styles.FilterTitle}`}>
                    Filters
                    <span onClick={(e) => setFilterOpen(false)}><ArrowRight /></span>
                </p>
                <div className={`${styles.FilterCard} ${styles.Select} ${styles.Width180} CusSelectFilter Filter Autocomplete`}>
                    <FilterAutocomplete
                        label="Status"
                        options={statusOptions}
                        value={filterData?.status}
                        onChange={(value) => updateFilter("status", value)}
                    />
                </div>
                <div className={`${styles.FilterCard} ${styles.Select} ${styles.Width180} CusSelectFilter Filter Autocomplete`}>
                    <FilterAutocomplete
                        label="Location"
                        options={locationOptions}
                        value={filterData?.location}
                        onChange={(value) => updateFilter("location", value)}
                    />
                </div>
                <div className={`${styles.FilterCard} ${styles.Select} ${styles.Width250} CusSelectFilter Filter Autocomplete`}>
                    <FilterAutocomplete
                        label="Product"
                        options={productOptions}
                        value={filterData?.product}
                        onChange={(value) => updateFilter("product", value)}
                    />
                </div>
            </div>
            {isAuthenticated && user["https://propertydek.com/permissions"].indexOf("device:create") > -1 && <>
                <Link className={`${styles.FilterBu}`} onClick={(e) => setFilterOpen(true)}>
                    <Filter />
                </Link>
                <Dropdown>
                    <Dropdown.Toggle
                        className={`${styles.ActionsBU} ${styles.Red} ActionsBU Red`} id="dropdown-basic">
                        <Plus /> <span className={`${styles.AddBuText}`}>Device</span>
                    </Dropdown.Toggle>

                    <Dropdown.Menu className={`${styles.ActionsBUList} ActionsBUList`}>
                        <Dropdown.Item className={`${styles.EditActionsBUListItem}`} onClick={(e) => setShowAddFormNew(true)}>
                            <Smartphone /> Tuya Device
                        </Dropdown.Item>
                        <Dropdown.Item className={`${styles.EditActionsBUListItem}`} onClick={(e) => setShowAddFormNew2(true)}>
                            <Key /> TTLock Device
                        </Dropdown.Item>
                    </Dropdown.Menu>
                </Dropdown>
            </>}
        </div>
    </div>;
}

export default DeviceFilter;